import type { ImportBasePath } from './types'

export const IMPORT_PARENT_PATHS = {
  '/clients/import': '/clients',
  '/expenses/import': '/expenses',
  '/invoices/import': '/invoices',
  '/line-items/import': '/line-items',
  '/quotes/import': '/quotes',
} as const satisfies Record<ImportBasePath, string>

export const IMPORT_DOCS_PATHS = {
  '/clients/import': '/docs/importing-data/clients',
  '/expenses/import': '/docs/importing-data/expenses',
  '/invoices/import': '/docs/importing-data/invoices-and-quotes',
  '/line-items/import': '/docs/importing-data/line-items',
  '/quotes/import': '/docs/importing-data/invoices-and-quotes',
} as const satisfies Record<ImportBasePath, string>
